module.exports = __webpack_public_path__ + "img/customer05.cc680241.jpg";